import VueRouter, { RouteConfig } from 'vue-router'

const OneHourRank = () => import('../views/one-hour/Rank.vue')
const OneHourRankShare = () => import('../views/one-hour/RankShare.vue')
const OneHourClazzStudentList = () => import('../views/one-hour/ClazzStudentList.vue')
const OneHourSchoolClazzList = () => import('../views/one-hour/SchoolClazzList.vue')
const OneHourStudentDetail = () => import('../views/one-hour/StudentDetail.vue')
const OneHourStudentItemList = () => import('../views/one-hour/StudentItemList.vue')
const SelfApplyLilst = () => import('../views/one-hour/SelfApplyList.vue')
const SelfApplySetting = () => import('../views/one-hour/SelfApplySetting.vue')

const clazzStudentRoute: RouteConfig = {
  path: '/one-hour-clazz-student-list',
  name: 'one_hour_clazz_student_list',
  component: OneHourClazzStudentList,
  meta: {
    title: '班级学生详情',
  },
}

const schoolCLazzRoute: RouteConfig = {
  path: '/one-hour-school-clazz-list',
  name: 'one_hour_school_clazz_list',
  component: OneHourSchoolClazzList,
  meta: {
    title: '学校班级详情',
  },
}

const studentDetailRoute: RouteConfig = {
  path: '/one-hour-student-detail',
  name: 'one_hour_student_detail',
  component: OneHourStudentDetail,
  meta: {
    title: '学生详情',
  },
}

const studentItemListRoute: RouteConfig = {
  path: '/one-hour-student-item-list',
  name: 'one_hour_student_item_list',
  component: OneHourStudentItemList,
  meta: {
    title: '学生运动明细',
  },
}

const selfApplyList: RouteConfig = {
  path: '/one-hour-self-apply-list',
  name: 'one_hour_self_apply_list',
  component: SelfApplyLilst,
  meta: {
    title: '运动申报记录',
  },
}

const selfApplySetting: RouteConfig = {
  path: '/one-hour-self-apply-setting',
  name: 'one_hour_self_apply_setting',
  component: SelfApplySetting,
  meta: {
    title: '运动申报设置',
  },
}

export default [
  {
    path: '/one-hour-rank',
    name: 'one_hour_rank',
    component: OneHourRank,
    meta: {
      title: '排行榜',
      keepAlive: true,
    },
  },
  {
    path: '/one-hour-rank-share',
    name: 'one_hour_rank_share',
    component: OneHourRankShare,
    meta: {
      title: '排行榜',
      ignoreLogin: true,
    },
  },
  clazzStudentRoute,
  schoolCLazzRoute,
  studentDetailRoute,
  studentItemListRoute,
  selfApplyList,
  selfApplySetting,
] as RouteConfig[]

export function navigateToOneHourClazzStudentList(router: VueRouter, clazzId: number, date?: string) {
  return router.push({ name: clazzStudentRoute.name, query: { clazzId: clazzId.toString(), date } })
}

export function navigateToOneHourSchoolClazzList(router: VueRouter) {
  return router.push({ name: schoolCLazzRoute.name })
}

export function navigateToOneHourStudentDtail(router: VueRouter, userId: string, date?: string) {
  return router.push({ name: studentDetailRoute.name, query: { userId, date } })
}
